import { mergeUniforms } from "three/src/renderers/shaders/UniformsUtils.js";
import TochiShader from "./TochiShader";
import { SkinChunk, DecalChunk } from "./TochiShaderChunks";

export const RGBGradientMaskShader = (
    maxlen: number,
    rlen: number,
    glen: number,
    blen: number,
    isDecal: boolean
): TochiShader => {
    return {
        uniforms: mergeUniforms([
            SkinChunk.uniforms,
            isDecal ? DecalChunk.uniforms : {},
            {
                rgbMask: { value: null },
                gradientMask: { value: null },
                rcolors: { type: "fv1", value: null },
                gcolors: { type: "fv1", value: null },
                bcolors: { type: "fv1", value: null },
                rcolorPos: { value: null },
                gcolorPos: { value: null },
                bcolorPos: { value: null }
            }
        ]),
        vertexShader: `
      #include <tochi_skin_vert_premain>
      void main() {
        #include <tochi_skin_vert_main>
      }
    `,
        fragmentShader: `
      #define NUM_MASKS 3
      #define numColors ${maxlen}
      #define rnumColors ${rlen}
      #define gnumColors ${glen}
      #define bnumColors ${blen}
      #define isDecal ${isDecal}
      uniform sampler2D rgbMask;
      uniform sampler2D gradientMask;
      uniform vec3 rcolors[numColors];
      uniform vec3 gcolors[numColors];
      uniform vec3 bcolors[numColors];
      uniform float rcolorPos[numColors];
      uniform float gcolorPos[numColors];
      uniform float bcolorPos[numColors];
      varying vec2 vUv;

      #include <tochi_skin_frag_premain>
      #include <tochi_decal_frag_premain>
      #include <tochi_colorlerp_frag_premain>

      void main() {
              
        // Get luma
        vec4 rgbMask = texture2D(rgbMask, vUv);
        vec4 gradientMask = texture2D(gradientMask, vUv);
        float l = dot(gradientMask.rgb, vec3(0.299, 0.587, 0.114));

        vec4 result = vec4(0);
        vec3 rcol = vec3(0.);
        for (int i=0; i < rnumColors; i++){
            rcol +=  color_lerp(rcolors, rcolorPos, rnumColors, l,  i); 
        }
        vec3 gcol = vec3(0.);
        for (int i=0; i < gnumColors; i++){
            gcol +=  color_lerp(gcolors, gcolorPos, gnumColors, l,  i); 
        }
        vec3 bcol = vec3(0.);
        for (int i=0; i < bnumColors; i++){
            bcol +=  color_lerp(bcolors, bcolorPos, bnumColors, l,  i); 
        }
        result += vec4(rcol, rgbMask.a) * rgbMask.r;
        result += vec4(gcol, rgbMask.a) * rgbMask.g;
        result += vec4(bcol, rgbMask.a) * rgbMask.b;

        gl_FragColor = result;
        if (isDecal) {
          #include <tochi_decal_frag_main>
        }
        #include <tochi_skin_frag_main>
      }
    `
    };
};
